import React, { useContext } from "react";
import { Avatar, Empty } from "antd";
import Moment from "react-moment";
import { useHistory } from "react-router-dom";

import CustomTable from "components/widgets/table";
import { DashboardContext } from "context/DashboardContext";

export default function RecentRequests({ data }) {
  const context = useContext(DashboardContext);
  const { quotationRequests, setQuotationRequests } = context;
  const history = useHistory();

  // Function to get initials from client names with robust error handling
  const getInitials = (names) => {
    if (!names || typeof names !== "object" || !names.fName) {
      return "?";
    }
    const firstInitial = names.fName.charAt(0).toUpperCase() || "";
    const lastInitial = names.lName ? names.lName.charAt(0).toUpperCase() : "";
    return `${firstInitial}${lastInitial}`;
  };

  // Get the last 5 records, ensuring data is an array
  const rows = Array.isArray(data) ? data : [];

  // Navigate to the quotation request view
  const view_quotation_request = (id) => {
    if (id) {
      history.push(`/dashboard/view-client-help-request/${id}`);
    }
  };

  const tableData = {
    icon: "",
    title: "",
    table_fields: [
      { name: "", align: "c" }, // For avatar
      { name: "Client", align: "c" },
      { name: "Expiry Date", align: "c" },
      { name: "Status", align: "c" },
      { name: "Action", align: "c" },
    ],
    search_fields: ["quotationRequestRef", "status"],
    row_data: [
      {
        type: "image",
        field: "clientDetails.names.firstName",
        class: "center",
        render: (names) => (
          <Avatar style={{ backgroundColor: "#1890ff" }}>
            {getInitials(names)}
          </Avatar>
        ),
      },
      {
        type: "text",
        field: "clientDetails.names.firstName",
        class: "center",
        render: (names) =>
          names && names.fName ? `${names.fName} ${names.lName || ""}` : "N/A",
      },
      {
        type: "date",
        field: "expiry",
        class: "center",
        render: (value) =>
          value ? <Moment format="YYYY/MM/DD">{value}</Moment> : "N/A",
      },
      {
        type: "status",
        field: "status",
        class: "center",
        render: (value) => (
          <span
            className={`badge badge-${value === "PENDING" ? "warning" : "success"}`}
          >
            {value || "N/A"}
          </span>
        ),
      },
      {
        type: "action",
        field: "quotationRequestRef",
        class: "center",
        icon: "",
        actions: [
          {
            type: "menu",
            title: "View",
            field: "quotationRequestRef",
            method: view_quotation_request,
          },
        ],
      },
    ],
  };

  return (
    <div className="col-md-12 col-xl-12" style={
        { borderRadius: "12PX", background: "#ffffff",   padding:"2rem"}
      }>
      <div className="#card rounded-10 mg-b-20">
        <div className="#card-header">
          <h4 className="card-header-title">Recent Quotation Requests</h4>
        </div>
        <div className="card-body pd-0 collapse show" id="customerDetails">
          {rows.length > 0 ? (
            <CustomTable
              table_fields={tableData.table_fields}
              row_data={tableData.row_data}
              table_data={rows}
              title={tableData.title}
            />
          ) : (
            <Empty description="No recent quotation requests" />
          )}
        </div>
      </div>
    </div>
  );
}